module.exports = __webpack_public_path__ + "img/6.43e6c9ff.png";